import React from "react";
import useTranslate from "../../hooks/useTranslate";

// Sort tabs "Latest | Top this week" — frames 1a/1n. Underline style: active
// tab 600 #111827 with a 2px #2283FF bottom edge, inactive 500 #6B7280.
const SortTabs = ({ sort, onChange }) => {
  const { t } = useTranslate();
  const tabs = [
    { key: "latest", label: t("Latest") },
    { key: "top", label: t("Top this week") },
  ];
  return (
    <div className="flex gap-[18px] min-[402px]:gap-5 sm:gap-[22px] border-b border-[#E4E9F0]">
      {tabs.map((tab) => {
        const isActive = sort === tab.key;
        return (
          <button
            key={tab.key}
            type="button"
            onClick={() => onChange(tab.key)}
            className={[
              "px-0.5 pb-2 min-[402px]:pb-[9px] text-[13.5px] whitespace-nowrap -mb-px",
              isActive
                ? "font-semibold text-[#111827] border-b-2 border-[#2283FF]"
                : "font-medium text-[#6B7280] border-b-2 border-transparent",
            ].join(" ")}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
};

export default SortTabs;
